import React from "react";
import { toast } from "react-toastify";
import { describeApiError, shortRef, signInPath } from "./apiError";
import { captureError } from "./tracking";

const linkStyle = { color: "inherit", fontWeight: 600, textDecoration: "underline" };
const refStyle = { display: "block", marginTop: 4, fontSize: 12, opacity: 0.7 };

export function ErrorToastBody({ info }) {
  return (
    <div>
      <span>{info.message}</span>
      {info.kind === "unauthenticated" && !window.location.pathname.startsWith("/auth") && (
        <>
          {" "}
          <a href={signInPath()} style={linkStyle}>
            Sign in
          </a>
        </>
      )}
      {info.requestId && <span style={refStyle}>Ref: {shortRef(info.requestId)}</span>}
    </div>
  );
}

// Resolves the next time the browser comes back online (immediately if
// it already is).
export function whenOnline() {
  if (typeof navigator === "undefined" || navigator.onLine !== false) return Promise.resolve();
  return new Promise((resolve) => window.addEventListener("online", () => resolve(), { once: true }));
}

// Report errors the server never saw (it was unreachable, or a proxy
// answered without our error code) — the rest are captured server-side.
export function captureIfUnseen(err, info) {
  if (info.kind === "network" || (info.kind === "server" && !info.code)) {
    captureError(err, { errorKind: info.kind, errorCode: info.code, flow: info.flow, requestId: info.requestId });
  }
}

// Non-blocking toast for a failed request. Returns the description so the
// caller can also show it inline. Paywall/permission errors are left to
// the existing paywall flow.
export function notifyApiError(err, { flow, toastId } = {}) {
  const info = describeApiError(err, { flow });
  if (info.kind === "canceled" || info.kind === "forbidden") return info;
  captureIfUnseen(err, info);
  const id = toastId || `api-${info.kind}`;
  toast.error(<ErrorToastBody info={info} />, {
    toastId: id,
    autoClose: info.kind === "offline" || info.kind === "unauthenticated" ? false : 6000,
  });
  if (info.kind === "offline") whenOnline().then(() => toast.dismiss(id));
  return info;
}
